
import { useRef } from 'react';
import { Link } from 'react-router-dom';

const products = [
  {
    id: 1,
    category: 'Premium Pulses',
    name: 'Toor Dal & Moong Dal',
    image: 'https://public.readdy.ai/ai/img_res/9d09fc190b1c8146e358af6cd7c38270.jpg',
  },
  {
    id: 2,
    category: 'Premium Spices',
    name: 'Turmeric & Red Chili',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20red%20chili%20powder%20and%20golden%20turmeric%20powder%20in%20elegant%20white%20bowls%20on%20clean%20white%20marble%20countertop%20with%20professional%20lighting%20studio%20style%20product%20photography%20simple%20minimalist%20background%20highlighting%20rich%20colors%20and%20fine%20texture%20of%20premium%20Indian%20spices%20for%20export&width=280&height=280&seq=prod-002&orientation=squarish',
  },
  {
    id: 3,
    category: 'Premium Rice',
    name: 'Basmati Rice',
    image: 'https://readdy.ai/api/search-image?query=Premium%20long%20grain%20white%20basmati%20rice%20displayed%20in%20modern%20white%20ceramic%20bowl%20on%20pristine%20white%20marble%20surface%20with%20soft%20diffused%20lighting%20professional%20product%20photography%20simple%20clean%20background%20showcasing%20individual%20rice%20grains%20and%20premium%20quality%20for%20export%20business&width=280&height=280&seq=prod-003&orientation=squarish',
  },
  {
    id: 4,
    category: 'Premium Maize',
    name: 'Yellow Corn',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20golden%20yellow%20corn%20kernels%20and%20whole%20corn%20cobs%20arranged%20in%20white%20bowl%20on%20clean%20white%20marble%20surface%20with%20natural%20soft%20lighting%20professional%20studio%20product%20photography%20simple%20minimalist%20background%20highlighting%20texture%20and%20vibrant%20color%20of%20premium%20maize%20for%20agricultural%20export&width=280&height=280&seq=prod-004&orientation=squarish',
  },
  {
    id: 5,
    category: 'Premium Coffee',
    name: 'Arabica Coffee Powder',
    image: 'https://readdy.ai/api/search-image?query=Rich%20dark%20brown%20arabica%20coffee%20powder%20in%20elegant%20white%20ceramic%20bowl%20on%20clean%20white%20marble%20countertop%20with%20soft%20professional%20lighting%20studio%20product%20photography%20simple%20minimalist%20background%20showcasing%20fine%20grind%20texture%20and%20deep%20color%20of%20premium%20coffee%20for%20export%20business&width=280&height=280&seq=prod-005&orientation=squarish',
  },
  {
    id: 6,
    category: 'Premium Tea',
    name: 'Assam Tea Powder',
    image: 'https://readdy.ai/api/search-image?query=Premium%20assam%20tea%20powder%20dark%20brown%20color%20in%20white%20ceramic%20bowl%20on%20pristine%20white%20marble%20surface%20with%20natural%20soft%20lighting%20professional%20studio%20product%20photography%20simple%20clean%20background%20highlighting%20fine%20texture%20and%20rich%20color%20of%20quality%20tea%20leaves%20for%20export&width=280&height=280&seq=prod-006&orientation=squarish',
  },
];

export default function ProductShowcase() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 304;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section id="products" className="py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 sm:mb-10 md:mb-12 gap-4">
          <div className="flex-1">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-3 sm:mb-4">
              Our Premium{' '}
              <span className="text-orange-500">Product Range</span>
            </h2>
            <p className="text-gray-600 text-sm sm:text-base">
              Sourced from India's finest agricultural regions
            </p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
              aria-label="Scroll left"
            >
              <i className="ri-arrow-left-s-line text-xl text-gray-700"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
              aria-label="Scroll right"
            >
              <i className="ri-arrow-right-s-line text-xl text-gray-700"></i>
            </button>
          </div>
        </div>

        {/* Product Horizontal Scroll */}
        <div
          ref={scrollRef}
          className="flex gap-4 sm:gap-5 md:gap-6 overflow-x-auto scroll-smooth pb-4"
          data-product-shop
          style={{ 
            scrollbarWidth: 'none', 
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch'
          }}
        >
          {products.map((product) => (
            <Link
              key={product.id}
              to="/products"
              className="flex-shrink-0 w-72 bg-gray-50 rounded-2xl sm:rounded-3xl overflow-hidden hover:shadow-xl transition-shadow cursor-pointer"
            >
              <div className="w-72 h-72">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 sm:p-5 md:p-6">
                <p className="text-xs sm:text-sm text-gray-500 mb-2">{product.category}</p>
                <div className="flex items-center justify-between gap-3">
                  <h3 className="text-sm sm:text-base font-semibold text-gray-800 flex-1">
                    {product.name}
                  </h3>
                  <span className="px-3 sm:px-4 py-1.5 sm:py-2 bg-emerald-700 text-white text-xs sm:text-sm rounded-full hover:bg-emerald-800 transition-colors whitespace-nowrap">
                    View Details
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All Products Link */}
        <div className="mt-8 sm:mt-10 text-center">
          <Link
            to="/products"
            className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-emerald-700 text-white rounded-full text-sm sm:text-base font-semibold hover:bg-emerald-800 transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            View All Products
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>

      <style>{`
        #products > div > div::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
}
